import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { CrmJobDTO, CustomFieldEnum, getCrmJobById } from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import { isBlank } from '../../../utils/StringUtils';
import { useCustomFields } from '../../clientListingPage/hooks/useCustomFields';

import CrmJobForm from './CrmJobForm';

interface CreateCrmJobDrawerProps {
  open: boolean;
  onClose: () => void;
  crmJobId: string | null;
  postSubmit?: (crmJob: CrmJobDTO) => void;
}

const CreateCrmJobDrawer = ({ open, onClose, crmJobId, postSubmit }: CreateCrmJobDrawerProps) => {
  const { customFields, defaultFields, loading } = useCustomFields(CustomFieldEnum.CRM_JOB);
  const [crmJobData, setCrmJobData] = useState<CrmJobDTO>();

  useEffect(() => {
    const fetchData = async () => {
      if (crmJobId) {
        try {
          const response = await getCrmJobById(crmJobId);
          setCrmJobData(response.data);
        } catch (error) {
          console.error('Error fetching CRM job data:', error);
        }
      }
    };
    fetchData();
  }, [crmJobId]);

  if (!isBlank(crmJobId) && !crmJobData) return null;

  return (
    <WsDrawer
      open={open}
      onClose={onClose}
      size="medium"
      title={crmJobId ? 'Edit Job' : 'Add Job'}
      headerSize="medium"
    >
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
          <CircularProgress />
        </Box>
      ) : (
        <CrmJobForm
          defaultCrmJobData={crmJobData}
          postSubmit={postSubmit}
          handleClose={onClose}
          customFields={customFields || []}
          defaultFields={defaultFields || []}
        />
      )}
    </WsDrawer>
  );
};

export default CreateCrmJobDrawer;
